import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';
import { RAMTableColumn } from './RAMTable.interface';
import { useRAMTable } from './useRAMTable';
import { formatPercentage } from './utils/formatPercentage';

const column: readonly RAMTableColumn[] = [
    { 
        id: 'no',
        label: 'No',
        minWidth: 80,
        align: 'center',
    },
    { 
        id: 'tagNumber',
        label: 'Tag\u00a0Name',
        minWidth: 200,
        align: 'left'
    },
    {
        id: 'equipmentType',
        label: 'Object\u00a0Type',
        minWidth: 100,
        align: 'left',
    },
    {
        id: 'mttf',
        label: 'MTTF\u00a0(year)',
        minWidth: 50,
        align: 'center',
    },
    {
        id: 'failureRate',
        label: 'Failure\u00a0Rate\u00a0(Faults/Year)',
        minWidth: 150,
        align: 'center',
    },
    {
        id: 'mttr',
        label: 'MTTR\u00a0(Year)',
        minWidth: 150,
        align: 'center',
    },
    {
        id: 'operationTime',
        label: 'Operation\u00a0Time\u00a0(Year)',
        minWidth: 100,
        align: 'center'
    },
    {
        id: 'probabilityOfSuccess',
        label: 'Probability\u00a0of\u00a0Success\u00a0(R)',
        minWidth: 100,
        align: 'center',
        format: (value) => formatPercentage(value)
    },
    {
        id: 'availability',
        label: 'Availability',
        minWidth: 100,
        align: 'center',
        format: (value) => formatPercentage(value)
    },
    {
        id: 'unavailability',
        label: 'Unavailability',
        minWidth: 100,
        align: 'center',
        format: (value) => formatPercentage(value)
    },
    {
        id: 'm',
        label: 'M\u00a0(t)',
        minWidth: 100,
        align: 'center',
        format: (value) => formatPercentage(value)
    },
    {
        id: 'remainingOfLife',
        label: 'Remaining\u00a0of\u00a0Life\u00a0(Year)',
        minWidth: 100,
        align: 'center'
    }
];

const TABLE_ELEMENT_HEIGHT = 61

const RAMTableSystem = () => {
    const { assetStore } = useStore();
    const { elementsHeight } = assetStore;
    const { card: c, etc, other: s } = elementsHeight;
    const { list } = useStore().ramStore;
    
    const { 
        rows, 
        handleChangePage, 
        handleChangeRowsPerPage, 
        page, 
        rowsPerPage,
    } = useRAMTable('system', list)
  
    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ height: c - s - etc - TABLE_ELEMENT_HEIGHT }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {column.map((column, x) => {
                                return (
                                    <TableCell
                                    key={x}
                                    align="center"
                                    style={{ minWidth: column.minWidth }}
                                    >
                                    {column.label}
                                    </TableCell>
                                )
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((row, x) => {
                              return (
                              <TableRow hover role="checkbox" tabIndex={-1} key={x}>
                                  {column.map((column, idx) => {
                                    const value = (row as any)[column.id];

                                    return (
                                        <TableCell key={idx} align={column.align}>
                                          {column.format && typeof value === 'number'
                                              ? column.format(value)
                                              : value}
                                        </TableCell>
                                    );
                                  })}
                              </TableRow>
                              );
                          })
                        }
                        {rows.length === 0 && <TableRow><TableCell colSpan={7}>No data to display</TableCell></TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}

export default observer(RAMTableSystem)